<template>
    <div>
        <!-- 清关信息详情 -->
        <compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getBase" :value="formData" :labelWidth="120" col="1"></compFormQuery>
        <compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" :labelWidth="120" col="1"></compFormEdit>

		<div class="text-right">
			<vButton theme="primary" class="margin-right-10" @click="submit">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
			<vButton @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
		</div>
    </div>
</template>

<script>
import { HttpGetContry } from '@/service/boss/dictionary'
export default {
	props:['alltype','cleardata'],
    components: {
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
    },
    data(){
        return {
			formData:{
				countryCode:'',
			},
			countries:[],
        }
	},
	created(){
		if(this.cleardata){
			this.handledata()
		}
		this.getcountry()
	},
    computed:{
        getBase(){
            return [
                {
					label: this.$tc('global.common.country',2,{defaultValue:'国家编码'}),
					key: "countryCode",
                    tag: "vSelect",
                    required:false,
					options: this.countries.map((item) => {
						return {
							value: item.code,
							label: item.code + " (" + item.name + ")"
						}
					}),
					props: {
						filterable: true,
					}
                },
                {
					label: "HS Code",
					key: "customCode",
					tag: "vInput",
                },
                {
					label: this.$t('global.common.currency',{defaultValue:'币种'}),
					key: "currencyCode",
					tag: "vSelect",
					options: [
                        {value:'USD',label:'USD'}
                    ],
					props: {
						filterable: true,
					}
                },
                {
					label: "FOB",
					key: "fobPrice",
					tag: "vInput",
                },
                {
					label: this.$t('erp.product.tariff',{defaultValue:'关税(%)'}),
					key: "importTaxRate",
					tag: "vInput",
                },
                {
					label: this.$t('erp.product.clear_discount',{defaultValue:'清关折扣率(%)'}),
					key: "customDiscountRate",
					tag: "vInput",
                },
                {
					label: this.$t('erp.product.clear_price',{defaultValue:'清关价'}),
					key: "customDiscountPrice",
					tag: "vInput",
					required: false,
                },
                {
					label: this.$t('erp.product.clear_remark',{defaultValue:'清关说明'}),
					key: "customRemark",
					tag: "vInput",
					required: false,
                },
                {
					label: this.$t('erp.product.estimated_freight',{defaultValue:'预估运费(USD)'}),
					key: "antcipatedFreight",
					tag: "vInput",
					required: false,
                },
            ]
        }
	},
	methods:{
		handledata(){
			this.formData = this.cleardata
		},
		getcountry(){
			if(this.alltype == 'query') return

            HttpGetContry({
                "search[EQ_depth]":2
            }).then(res=>{
                this.countries = res.data
            },err=>{

            })
		},
		submit(){
			// console.log(this.formData)
			this.$emit('on-update',this.formData)
		},
		cancel(){
			this.$emit('on-close')
		}
	}
}
</script>